import { ChangeEventHandler, DragEventHandler, useCallback } from "react";
// components
import DataTransferUploaderUI from "./components/data-transfer-uploader-ui";
// constants
import { UPLOAD_FILE_ACCEPT } from "../../../../constants";
// hooks
import { useDataTransferContext } from "../../../../contexts/DataTransferContext";
// types
import type { ModalLayoutProps } from "components/modal/modal-layout/ModalLayout";

type Props = ModalLayoutProps & {
  source: string;
  onHide: () => void;
};

/**
 * renders the UI for upload/import data
 */
const DataTransferUploader = ({ source, onHide, ...rest }: Props) => {
  const { onUpload, onHideUploader, uploadTaskStates } =
    useDataTransferContext();
  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      if (!event.target?.files?.length) {
        return;
      }

      onUpload([...event.target.files], source);
    },
    [onUpload, source],
  );

  const onDrop = useCallback<DragEventHandler<HTMLDivElement>>(
    (event) => {
      if (!event.dataTransfer?.items?.length) {
        return;
      }

      const validItems: File[] = [];

      for (const item of event.dataTransfer.items) {
        if (UPLOAD_FILE_ACCEPT.includes(item.type)) {
          const file = item.getAsFile();
          if (file) {
            validItems.push(file);
          }
        }
      }
      onUpload(validItems, source);
    },
    [onUpload, source],
  );

  return (
    <DataTransferUploaderUI
      onDrop={onDrop}
      onChange={onChange}
      uploadTaskStates={uploadTaskStates}
      onHide={() => {
        onHide();
        onHideUploader();
      }}
      {...rest}
    />
  );
};

export default DataTransferUploader;
